import { GenexLMSModel } from "@/models/lms/GenexLMSModel";
import { normalize } from "@/utils/data";
import Course from "@/models/lms/Course";
import User from "@/models/lms/User";
import Module from "@/models/lms/Module";
import ModuleEntity from "@/models/lms-central/ModuleEntity";
import { LMSAssessmentQuestion } from "@/models/lms/LMSAssessmentQuestion";

export class LMSAssessment extends GenexLMSModel {
  static entity = "Modules\\AssessmentBuilder\\Entities\\Assessment";

  static fields() {
    return {
      id: this.attr(null),
      course_id: this.attr(null),
      course: this.belongsTo(Course, "course_id"),
      title: this.attr(""),
      // display_name: this.attr(null),
      is_checkpoint: this.attr(1),
      module_id: this.attr(null),
      module: this.belongsTo(Module, "module_id"),
      max_attempts: this.attr(0),
      course_scope_id: this.attr(null),
      course_scope_code: this.attr(""),
      difficulty_1_count: this.attr(0),
      difficulty_2_count: this.attr(0),
      difficulty_3_count: this.attr(0),
      assessment_questions_count: this.attr(0),
      assessment_questions_learning_objectives_count: this.attr(0),
      assessment_questions_total_marks: this.attr(0),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      creator_id: this.attr(null),
      assessment_type_id: this.attr(null),
      creator: this.belongsTo(User, "creator_id"),
      order: this.attr(0),
      completed: this.attr(0),
      assessment_questions: this.hasMany(LMSAssessmentQuestion, "assessment_id"),
      restriction_description: this.attr(""),
      restrictions_count: this.attr(null),
      answer_display_handling: this.attr(0),
      pass_mark: this.attr(0),
      module_entity: this.morphMany(ModuleEntity, 'moduleable_id', 'moduleable_type')
    };
  }

  static FetchAll({ page = 1, limit = 15 }, query = {}, relationships = []) {
    return this.apiWithHeaders().get(`assessments`, {
      params: {
        ...{
          page: page,
          limit: limit,
          with: relationships,
        },
        ...(query !== {} ? query : {}),
      },
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
      save: true,
    });
  }

  static FetchById(id, relationships = [], moduleOverrideKeys= null, query) {
    return this.apiWithHeaders().get(`assessments/${id}`, {
      params: {
        ...{
          with: relationships,
        },
        ...(query !== {} ? query : {}),
      },
      dataTransformer: ({ data: { data } }) => {
        if(moduleOverrideKeys){
          let normalData = normalize(data);
          return {...normalData, ...moduleOverrideKeys}
        }
        return normalize(data);
      },
    });
  }

  static Store(data) {
    return this.apiWithHeaders().post(`assessments`, data, {
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
      save: true,
    });
  }

  static Update(data) {
    return this.apiWithHeaders().patch(`assessments/${data.id}`, data, {
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
      save: true,
    });
  }

  static Delete(id) {
    return this.apiWithHeaders().delete(`assessments/${id}`, {
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
      delete: id,
    });
  }
}
